module.exports = __webpack_public_path__ + "img/bank_transfer.265492b1.svg";